import React from "react";

import { Box } from "@mui/material";

import { Paragraph, SubtitleStyles } from "../../types";
import SubtitleModeSwitcher from "./components/SubtitleModeSwitcher";
import StyleEditor from "./components/StyleEditor";
import SubtitlesEditor from "./components/SubtitlesEditor";
import CaptionAnimationControls from "./components/CaptionAnimationControls";
import CaptionPresets from "../CaptionPresets";

interface SubtitleProps {
  styles: SubtitleStyles;
  paragraphs: Paragraph[];
  onUpdateStyles: (styles: SubtitleStyles, paragraph?: Paragraph) => void;
  onUpdateParagraph: (paragraph: Paragraph) => void;
  currentTimeInMilliseconds: number;
  onParagraphClick: (ms: number) => void;
}

export default function Subtitle({
  styles,
  paragraphs,
  onUpdateStyles,
  onUpdateParagraph,
  currentTimeInMilliseconds,
  onParagraphClick,
}: SubtitleProps) {
  const [selectedTab, setSelectedTab] = React.useState(0);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <SubtitleModeSwitcher
        selectedTab={selectedTab}
        onSelectTab={setSelectedTab}
      />
      <Box
        data-scroll-container
        sx={{
          position: "relative",
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          pr: 0.5,
        }}
      >
        {selectedTab === 0 && (
          <CaptionPresets styles={styles} onUpdateStyles={onUpdateStyles} />
        )}

        {selectedTab === 1 && (
          <>
            <CaptionAnimationControls
              styles={styles}
              onUpdateStyles={onUpdateStyles}
            />
            <StyleEditor styles={styles} onUpdateStyles={onUpdateStyles} />
          </>
        )}

        {selectedTab === 2 && (
          <SubtitlesEditor
            paragraphs={paragraphs}
            onUpdateParagraph={onUpdateParagraph}
            currentTimeInMilliseconds={currentTimeInMilliseconds}
            onSeek={onParagraphClick}
          />
        )}
      </Box>
    </Box>
  );
}
